"use client";

import { createContext, useContext } from "react";

export interface PortalUser {
  id: string;
  name: string;
  email: string;
  role: string;
}

export interface PortalOrg {
  id: string;
  name: string;
  email: string;
  plan: string;
  balanceCents: number;
}

export interface PortalContextValue {
  user: PortalUser;
  org: PortalOrg;
}

export const PortalContext = createContext<PortalContextValue | null>(null);

export function usePortal(): PortalContextValue {
  const ctx = useContext(PortalContext);
  if (!ctx) throw new Error("usePortal must be used within PortalProvider");
  return ctx;
}

export function PortalProvider({
  value,
  children,
}: {
  value: PortalContextValue;
  children: React.ReactNode;
}) {
  return (
    <PortalContext.Provider value={value}>{children}</PortalContext.Provider>
  );
}
